
<div class="row mb-2 pt-3 px-2">
  <div class="col-sm-4">
  <h3>Training Details</h3>
</div>
  <div class="col-sm-8 text-md-end">
    <button class="btn btn-primary btn-sm me-3 cursor" [disabled]="['5','7','8','4','9','6'].includes(trainingStatus)"
    (click)="changeAssignee()">Change
    Assignee</button>
    <button class="btn btn-primary btn-sm ms-1"  *ngIf="!((!trainingInfo || !trainingInfo.training_event_time_slot_id) && api_hit == false)" (click)="editTrainingModal()">Edit Training Details</button>
    <button class="btn btn-primary btn-sm ms-1"  *ngIf="!detail_in_notification" (click)="location.back()">Back</button>
  </div>
</div>
<div class="card card-default" *ngIf="trainingInfo && !((!trainingInfo || !trainingInfo.training_event_time_slot_id) && api_hit == false)">
  <div class="card-body">
    <div>
      <div class="row">
        <!--Training Information-->
        <div class="col-12 mt-2"><b class="training_section">Training Information</b></div>
        <div class="col-4">
          <span class="text-muted training_attributes">Date:</span>
          {{trainingInfo.schedule_date ? (trainingInfo.schedule_date) : 'N.A.'}}
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Time:</span>
          {{trainingInfo.schedule_time ? trainingInfo.schedule_time : 'N.A.'}}
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Timezone:</span>
          <span *ngIf="timezoneName || trainingInfo.timezoneString">
            {{timezoneName + '(GMT'+trainingInfo.timezoneString+')'}}
          </span>
          <span *ngIf="!(timezoneName || trainingInfo.timezoneString)">
            N.A.
          </span>
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Assigned to:</span>
          <span *ngIf="trainingInfo.admin_name || trainingInfo.admin_email">
            {{trainingInfo.admin_name + ' ('+trainingInfo.admin_email+')'}}
          </span>
          <span *ngIf="!(trainingInfo.admin_name || trainingInfo.admin_email)">
            N.A.
          </span>
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Type of Training: </span>
          <span>{{trainingInfo.type_name || 'N.A.'}}</span>
          <!-- <span *ngIf="trainingInfo.type ==1">Initial Training</span>
          <span *ngIf="trainingInfo.type ==2">Refresher Training</span>
          <span *ngIf="trainingInfo.type ==3">New Feature Training</span>
          <span *ngIf="trainingInfo.type ==4">Demo</span> -->
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Status: </span>
          <span>{{trainingInfo.training_status_name || 'N.A.'}}</span>
          <!--<span *ngIf="trainingInfo.status == 1">New Registration</span>
          <span *ngIf="trainingInfo.status == 2">Scheduled</span>
          <span *ngIf="trainingInfo.status == 3">Rescheduled</span>
          <span *ngIf="trainingInfo.status == 4">Follow up</span>
          <span *ngIf="trainingInfo.status == 5">Completed</span>
          <span *ngIf="trainingInfo.status == 6">No show</span>
          <span *ngIf="trainingInfo.status == 7">Canceled</span>-->
        </div>
        <div class="col-4" *ngIf="(trainingInfo.training_status == 4 || trainingInfo.training_status == 9 || trainingInfo.training_status == 6) && trainingInfo.followup_date">
          <span class="text-muted training_attributes">Follow Up: </span>
          <span>
            {{ trainingInfo.followup_date | date:'MM/dd/yyyy hh:mm a': timezone }}
          </span>
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Source: </span>
          <span class="camel_case_string" *ngIf = "trainingInfo.training_source == 'doctor'">Business ({{trainingInfo.schedule_name ? trainingInfo.schedule_name : trainingInfo.training_doctor_partner_name}})</span>
          <span class="camel_case_string" *ngIf = "trainingInfo.training_source != 'doctor' && trainingInfo.training_source != 'admin'">{{trainingInfo.training_source ? trainingInfo.training_source : 'admin'}} ({{trainingInfo.schedule_name ? trainingInfo.schedule_name : ' '}})</span>
          <span class="camel_case_string" *ngIf = "trainingInfo.training_source == 'admin'">{{trainingInfo.training_source ? trainingInfo.training_source : 'admin'}} ({{trainingInfo.schedule_name ? trainingInfo.schedule_name : trainingNotes[trainingNotes.length-1].creator_admin_name}})</span>
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Note: </span>
          <span *ngIf="trainingInfo.training_timezone_short_name">This training was originally booked in {{trainingInfo.training_timezone_short_name}} for 
            {{trainingInfo.training_start_timestamp ? getDateTimeFromTimestampWithFormat(trainingInfo.training_start_timestamp, 'MM/DD/YYYY hh:mm A', trainingInfo.training_timezone_offset) : ''}}</span>
            <span *ngIf="!trainingInfo.training_timezone_short_name">N.A.</span>
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Meeting Link: </span>
          <span *ngIf="trainingInfo.training_meeting_link"><a target="_blank" href="{{trainingInfo.training_meeting_link}}">{{trainingInfo.training_meeting_link}}</a></span>
          <span *ngIf="!trainingInfo.training_meeting_link">N.A.</span>
        </div>
        <!--Business Owner Information-->
        <div class="col-12"><b class="training_section">{{trainingInfo.training_doctor_partner_type == 'doctor' ? 'Business Owner' :'Partner'}} Information</b></div>
        <div class="col-4" *ngIf="trainingInfo.training_doctor_partner_id != 0">
          <span class="text-muted training_attributes">Name:</span>
          <a [routerLink]="'/app/business/details/'+_shared.encodeId(trainingInfo.training_doctor_partner_id)" *ngIf="trainingInfo.training_doctor_partner_type == 'doctor'">
            {{trainingInfo.doctor_name}}
          </a>
          <a [routerLink]="'/app/partners/profile/'+trainingInfo.training_doctor_partner_id" *ngIf="trainingInfo.training_doctor_partner_type == 'partner'">
            {{trainingInfo.partner_name}}
          </a>
          <span *ngIf="trainingInfo.training_doctor_partner_type != 'partner' && trainingInfo.training_doctor_partner_type != 'doctor'">N.A.</span>
        </div>
        <div class="col-4" *ngIf="trainingInfo.training_doctor_partner_id == 0">
            <span class="text-muted training_attributes">Name:</span> {{trainingInfo.training_doctor_partner_name || 'N.A.'}}
          </div>
        <div class="col-4" *ngIf="trainingInfo.training_doctor_partner_id == 0">
          <span class="text-muted training_attributes">Email:</span>
          {{trainingInfo.training_trainee_emails}}
        </div>
        <div class="col-4" *ngIf="trainingInfo.training_doctor_partner_id != 0">
          <span class="text-muted training_attributes">Email:</span> 
          <span *ngIf="trainingInfo.training_doctor_partner_type == 'partner'">
            {{trainingInfo.partner_email || 'N.A.'}}
          </span>
          <span *ngIf="trainingInfo.training_doctor_partner_type != 'partner'">
            {{trainingInfo.doctor_email || 'N.A.'}}
          </span>
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Mobile:</span>
          <span *ngIf="trainingInfo.training_doctor_partner_type == 'partner'">
            {{ trainingInfo.partner_mobile ? '+1-' + trainingInfo.partner_mobile : (trainingInfo.training_doctor_partner_phone ? trainingInfo.training_doctor_partner_phone : 'N.A.') }}
          </span>
          <!-- training_doctor_phone is the owner's number as edited for this training (the edit modal's
               Training User Contact on an owner booking), so it belongs here, not under Business Information. -->
          <span *ngIf="trainingInfo.training_doctor_partner_type != 'partner'">
            {{(trainingInfo.training_doctor_partner_id != 0 && !(trainingInfo.training_agent_id > 0) && trainingInfo.training_doctor_phone) ? trainingInfo.training_doctor_phone : trainingInfo.doctor_mobile?'+1-' +(trainingInfo.doctor_mobile): trainingInfo.training_doctor_partner_phone?(trainingInfo.training_doctor_partner_phone) : 'N.A.'}}
          </span>
          
        </div>
        <div class="col-4">
          <span class="text-muted training_attributes">Type:</span> {{trainingInfo.training_doctor_partner_id != 0?'Registered':'Unregistered'}}
        </div>
        <!--Business Information-->
        <ng-container *ngIf="trainingInfo.training_doctor_partner_type == 'doctor'">
          <div class="col-12 mt-2"><b class="training_section">Business Information</b></div>
          <div class="col-4">
            <span class="text-muted training_attributes">Name:</span> {{( trainingInfo.training_doctor_name ? trainingInfo.training_doctor_name:trainingInfo.training_practice_name)|| 'N.A.'}}
          </div>
          <div class="col-4">
            <span class="text-muted training_attributes">Email:</span> {{(trainingInfo.training_doctor_email ? trainingInfo.training_doctor_email: trainingInfo.practice_email) || 'N.A.'}}
          </div>
          <div class="col-4">
            <span class="text-muted training_attributes">Mobile:</span>
            <!-- A registered business's own number is its profile's practice mobile; the per-training
                 override is the owner's (shown above). An unregistered one has no profile, so the number
                 entered at booking still lives in training_doctor_phone. -->
            {{
              (trainingInfo.training_doctor_partner_id == 0 && trainingInfo.training_doctor_phone)
                ? trainingInfo.training_doctor_phone
                : (trainingInfo.practice_mobile 
                     ? '+1-' + trainingInfo.practice_mobile 
                     : 'N.A.'
                  ) 
            }}
          </div>
          <div class="col-4" *ngIf="trainingInfo?.training_doctor_website_link">
            <span class="text-muted training_attributes">Website:</span> {{trainingInfo?.training_doctor_website_link  || 'N.A.'}}
          </div>
        </ng-container>
        <!--Agent Information-->

        <div *ngIf="trainingInfo.training_agent_id" class="col-12 mt-2"><b class="training_section">User Information</b></div>
        <!-- Every business user attending, with their details for this training; the training row's own
             user when the attendee list isn't available -->
        <ng-container *ngIf="trainingInfo.training_agent_id && trainingInfo.training_agents?.length">
          <ng-container *ngFor="let agent of trainingInfo.training_agents; let i = index">
            <div class="col-4">
              <span class="text-muted training_attributes">Name:</span> {{agent.training_agent_name || 'N.A.'}}<span
                *ngIf="i === 0 && trainingInfo.training_agents.length > 1"> (Primary)</span>
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Email:</span> {{agent.training_agent_email || 'N.A.'}}
            </div>
            <div class="col-4">
              <span class="text-muted training_attributes">Mobile:</span> {{agent.training_agent_phone || 'N.A.'}}
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="trainingInfo.training_agent_id && !trainingInfo.training_agents?.length">
          <div class="col-4">
            <span class="text-muted training_attributes">Name:</span> {{(trainingInfo.training_agent_name)|| 'N.A.'}}
          </div>
          <div class="col-4">
            <span class="text-muted training_attributes">Email:</span> {{(trainingInfo.training_agent_email) || 'N.A.'}}
          </div>
          <div class="col-4">
            <span class="text-muted training_attributes">Mobile:</span> {{(trainingInfo.training_agent_phone) || 'N.A.'}}
          </div>
        </ng-container>

      </div>

      <div class="mt-3" *ngIf="trainingNotes.length">
        <div><b>CSR Note</b></div>

        <!--
          Attribute each note to whoever performed THAT action, resolved per note by getEventDetails:
          creator_admin_name (admin), else creator_agent_name (business user), else creator_business_name
          (business owner). The trainingInfo.* expression is only a last resort for older notes that
          recorded no actor -- using it first named the business user even when the owner was the one who
          cancelled or rescheduled.
        -->
        <span>{{trainingNotes[trainingNotes.length-1].creator_admin_name || 'Added by
          '+(trainingNotes[trainingNotes.length-1].creator_agent_name || trainingNotes[trainingNotes.length-1].creator_business_name || (trainingInfo.training_agent_id ? trainingInfo.training_agent_name : (trainingInfo.training_doctor_name || trainingInfo.training_practice_name)))}} |
          {{trainingNotes[trainingNotes.length-1].doctor_partner_training_status_date_created | date:'MM/dd/yyyy hh:mm
          a':timezone}}{{trainingNotes[trainingNotes.length-1].training_status_name ? ' |
          '+trainingNotes[trainingNotes.length-1].training_status_name : '' }}</span>
        <p class="speech-bubble speech-bubble-full show-enter">{{trainingNotes[trainingNotes.length-1].training_event_desc}}</p>
      </div>
    </div>
  </div>
</div>

<div class="card card-default" *ngIf="!((!trainingInfo || !trainingInfo.training_event_time_slot_id) && api_hit == false)">
  <div class="card-header d-flex align-items-center justify-content-between">
    <span>Notes</span>
    <button class="btn btn-primary btn-sm" (click)="openAddNoteModal()">Add Note</button>
  </div>
  <div class="card-body">
    <div class="row filter-box mb-3">
      <div class="col-sm-6 col-md-4">
        <div class="form-group position-relative mb-2">
          <label class="fs-14 fw-400 m-0">Select Date Range: </label>
          <div class="d-flex align-items-center input_field p-0 overflow-hidden">
            <input readonly type="text" #notesRangePicker="bsDaterangepicker" bsDaterangepicker
              class="input_field border-0 border-end m-0 flex-fill rounded-0"
              [(ngModel)]="notesDateRangeValue" (ngModelChange)="notesDateChange()" [bsConfig]="dateConfig">
            <button class="bg-transparent border-0 h-100 hw-40" *ngIf="!notesResetBtn" (click)="notesRangePicker.toggle()">
              <i class="fa fa-calendar"></i>
            </button>
            <button class="reset-btn bg-transparent border-0 h-100 hw-40" (click)="notesResetDate()" *ngIf="notesResetBtn">
              <i class="fa fa-close"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4">
        <label class="fs-14 fw-400 m-0 mb-2">Select Admin</label>
        <ngx-select [items]="notesAdminList" optionValueField="admin_id" optionTextField="admin_name"
          (select)="notesSelectAdmin($event)" [allowClear]="true" (selectionChanges)="notesAdminClear($event)"
          placeholder="please enter admin name">
          <ng-template ngx-select-option-selected let-option>
            {{option.data.admin_name + ' ('+option.data.admin_email+')'}}
          </ng-template>
          <ng-template ngx-select-option let-option let-text="text">
            {{option.data.admin_name}} <br>
            <small>{{option.data.admin_email}}</small>
          </ng-template>
          <ng-template ngx-select-option-not-found>
            Not found
          </ng-template>
        </ngx-select>
      </div>
      <div class="col-sm-12 col-md-4">
        <label class="fs-14 fw-400 m-0">Search <span><i tooltip="Search by note text" class="fa fa-info-circle"></i></span></label>
        <div class="input-group" style="position: relative;">
          <input type="text" class="input_field" [(ngModel)]="notesSearchString"
            (keyup.enter)="applyNotesFilters()"
            placeholder="Type and press enter to search">
          <div class="input-group-append cross-icon" *ngIf="notesSearchString" (click)="notesResetSearch()">
            <i class="fa fa-close"></i>
          </div>
        </div>
      </div>
      <div class="col-12">
        <small class="text-muted">(Time in {{timezoneName || 'Pacific Time'}})</small>
      </div>
    </div>
    <div class="row" *ngFor="let note of filteredTrainingNotes">
      <div class="col">
        <p>{{note.creator_admin_name || 'Added by '+(note.creator_agent_name || note.creator_business_name || (trainingInfo.training_agent_id ? trainingInfo.training_agent_name : (trainingInfo.training_doctor_name || trainingInfo.training_practice_name)))}} | {{note.doctor_partner_training_status_date_created | date:'MM/dd/yyyy hh:mm a':timezone}}{{note.training_status_name ? ' | '+note.training_status_name : '' }}</p>
        <p class="speech-bubble show-enter" [innerHtml]="note.training_event_desc?.replaceAll('\n','<br/>')"></p>
        <div *ngIf="note.displayAttachments && note.displayAttachments.length" class="d-flex align-items-center flex-wrap">
          <a tappable [href]="doc.file_url" target="_blank"
            class="d-flex align-items-center justify-content-center m-1 border bg-dark"
            *ngFor="let doc of note.displayAttachments" style="height: 80px; width: 80px;">
            <img *ngIf="doc.thumb_url" [src]="doc.thumb_url" alt="" class="img-fluid">
            <i *ngIf="!doc.thumb_url" class="fa fa-file-text-o text-white fa-2x"></i>
          </a>
        </div>
      </div>
    </div>
    <p *ngIf="!filteredTrainingNotes.length && trainingNotes.length" class="text-muted mb-0">No notes match the selected filters.</p>
    <p *ngIf="!trainingNotes.length" class="text-muted mb-0">No notes yet.</p>
  </div>
</div>
<div class="card card-default" *ngIf="(!trainingInfo || !trainingInfo.training_event_time_slot_id) && api_hit == false">
  <div class="card-body">
    <div>
      <div class="wrapper">
        <div class="abs-center wd-xl">
          <div class="text-center mb-4">
            <div class="mb-3" style="font-size: 50px;">Oops!</div>
            <p class="lead m0">The training is no longer exists.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Add Note-->
<!-- <div bsModal #addNoteModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form #addNoteForm="ngForm" (ngSubmit)="addNoteForm.valid && addNote(addNoteForm, addNoteModal)">
        <div class="modal-header">
          <h4 class="modal-title">Add Note</h4>
          <button type="button" class="close" aria-label="Close" (click)="addNoteModal.hide()">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group"
            [ngClass]="{'has-error': (addNoteForm.submitted && new_note.invalid) || (new_note.touched && new_note.invalid)}">
            <label for="new_note">Note</label>
            <textarea id="new_note" cols="30" rows="4" [(ngModel)]="newNote" #new_note="ngModel" required
              name="new_note" class="form-control" placeholder="Enter note here..."></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex">
            <div>
              <button type="button" class="btn btn-outline-secondary mr-4" (click)="addNoteModal.hide();newNote=''">Cancel</button>
            </div>
            <div class="ms-auto">
              <button type="submit" class="btn btn-primary">Confirm</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div> -->